import { gql } from '@apollo/client';
export const StatFeatureMilkReport = gql `
    fragment StatFeatureMilkReport on MilkReportFeatureSettingsFlags {
        enabled
    }
`;
